// @ts-nocheck
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";

export default {
    name: "availableCategories",
    displayName: "Supported Categories",
    editorTemplate: "ListField",
    getDisplay: ({ fields: { name } }) => name,
    fieldType: "General",
    fieldDefinitions: [
        {
            name: "name",
            editorTemplate: "TextField",
            defaultValue: "",
        },
    ],
    defaultValue: [
        {
            fields: { name: "Accessories" },
        },
        {
            fields: { name: "All Products" },
        },
        {
            fields: { name: "Breakaway" },
        },
        {
            fields: { name: "Brisk Cooling" },
        },
        {
            fields: { name: "Class 2" },
        },
        {
            fields: { name: "Class 3" },
        },
        {
            fields: { name: "Enhanced Visibility" },
        },
        {
            fields: { name: "Flame Resistant" },
        },
        {
            fields: { name: "N/A" },
        },
        {
            fields: { name: "Non-Ansi" },
        },
        {
            fields: { name: "Outerwear" },
        },
        {
            fields: { name: "Pants & Gaiters E Class" },
        },
        {
            fields: { name: "Public Safety Vests" },
        },
        {
            fields: { name: "Rainwear" },
        },
        {
            fields: { name: "Surveyor" },
        },
        {
            fields: { name: "T-Shirts" },
        },
    ],
} as FieldDefinition;
